<template>
  <v-card>
    <v-card-title class="primary white--text">
      <v-icon>fas fa-sort</v-icon>
      <h2 class="title ml-2">Ordenar programas</h2>
    </v-card-title>
    <v-card-text>
      <v-list v-if="items">
        <draggable
          :list="items"
          ghost-class="ghost"
        >
          <v-list-item v-for="item in items" :key="item.id">
            <v-list-item-content>
              <v-list-item-title>{{item.nombre}}</v-list-item-title>
              <v-list-item-subtitle>{{item.horario}}</v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
        </draggable>
      </v-list>
    </v-card-text>
    <v-card-actions>
      <v-btn color="error" @click="$emit('close')">
        <v-icon left>fas fa-times</v-icon>
        cerrar
      </v-btn>
      <v-spacer></v-spacer>
      <v-btn color="primary" @click="$emit('save')">
        <v-icon left>fas fa-save</v-icon>
        guardar
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import draggable from 'vuedraggable'
export default {
  name: 'sort-progrmacion',
  props: ['items'],
  components: {
    draggable
  }
}
</script>

<style scoped>
.ghost {
  opacity: 0.5;
  background: #c5c5c5;
}
</style>
